import React, { useEffect, useState } from 'react';
import PipelineFieldHints from './PipelineFieldHints';

const STORAGE_KEY = 'crm.pipeline_hints_collapsed';

type Variant = 'pipeline' | 'inbound';

export interface CollapsibleFieldHintsProps {
  variant: Variant;
}

export const CollapsibleFieldHints: React.FC<CollapsibleFieldHintsProps> = ({ variant }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    try {
      setCollapsed(localStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      setCollapsed(false);
    }
  }, []);

  const toggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {
        /* ignore */
      }
      return next;
    });
  };

  const title = variant === 'pipeline' ? 'How pipeline leads work' : 'How inbound leads work';

  if (collapsed) {
    return (
      <button
        type="button"
        onClick={toggle}
        className="text-sm font-medium text-primary hover:underline text-left"
      >
        Show {title.toLowerCase()}
      </button>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={toggle}
          className="text-xs font-medium text-fg-muted hover:text-fg shrink-0"
          aria-label={`Dismiss ${title}`}
        >
          Dismiss
        </button>
      </div>
      <PipelineFieldHints variant={variant} />
    </div>
  );
};

export default CollapsibleFieldHints;
